//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Skypark from '@/api/promotores/usuarios/skypark.api'

export default {
	data() {
		return {
			per_page_options: [10, 20, 30, 40, 50, 100],
			columns: [
				{
					name: 'nombre',
					label: 'Nombre',
					field: 'firstname',
					align: 'left',
					classes: "bg-grey-2 ellipsis",
					style: "width: 300px",
					headerClasses: "bg-primary text-white"
				},
				{ name: 'apellidos', label: 'Apellidos', field: 'lastname', align: 'left' },
				{ name: 'email', label: 'Email', field: 'email', align: 'left' },
				{ name: 'telefono', label: 'Teléfono', field: 'phone', align: 'left' },
				{ name: 'status', label: 'Status', field: 'hs_lead_status', align: 'left', format: this.formatStatus },
				{ name: 'proyecto', label: 'Desarrollo', field: 'proyecto', align: 'left' },
				{ name: 'createdate', label: 'Creado', field: 'createdate', align: 'left' },

			],
			data: [],
			loading: false,
		}
	},

	mounted() {
		this.getContacts()
	},

	methods: {
		async getContacts() {
			try {
				this.loading = true
				this.data = (await Skypark.contacts(this.$route.params.promotor)).map(contact => contact.properties)
			} finally {
				this.loading = false;
			}
		},
		formatStatus(status) {
			return ({
				'NEW': 'Nuevo',
				'SIN_LOCALIZAR': 'Imposible de localizar',
				'IN_PROGRESS': 'Interesado',
				'CONDITIONS': 'Con Condicionantes',
				'NO_CALIFICADO': 'No Calificado',
				'BAD_TIMING': 'No por ahora',
				'OPEN_DEAL': 'Negocio abierto',
				'VENTA_GANADA': 'Venta Ganada',
				'VENTA_PERDIDA': 'Venta Perdida',
			})[status] || status
		},
	}

}
